import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import "./itemlists.css";
import axios from "axios";
import BASE_URL from "../../../config/apiConfig";
import {
  faCircleUser,
  faLeaf,
  faRmb,
  faSeedling,
  faTractor,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserEmail } from "../../../utils/auth";

function ItemLists({ type }) {
  const [farmCount, setFarmCount] = useState(0);
  const [subscriptionCount, setSubscriptionCount] = useState(0);
  const [plantationCount, setPlantationCount] = useState(0);
  const [fieldCount, setFieldCount] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch the counts for users and admin users from the backend
  useEffect(() => {
    const userEmail = getUserEmail();
    const fetchCounts = async () => {
      try {
        // Fetch farm count
        const farmCount = await axios.post(
          `${BASE_URL}/api/user/farm-management/get-all-added-farms`,
          {
            email: userEmail,
          }
        );
        console.log("Farm Count Response:", farmCount.data);
        setFarmCount(farmCount.data.length);

        // Fetch subscription count
        const subscriptionCount = await axios.post(
          `${BASE_URL}/api/payment/getTransactions`,
          { email: userEmail }
        );
        const plantationCount = await axios.post(
          `${BASE_URL}/api/user/fetch-plantation-farms`,
          { email: userEmail, type: "plantation" }
        );
        const fieldCount = await axios.post(
          `${BASE_URL}/api/user/fetch-field-farms`,
          { email: userEmail, type: "field" }
        );
        console.log("Subscription Count Response:", subscriptionCount.data);
        setSubscriptionCount(subscriptionCount.data.transactions.length);

        setFieldCount(fieldCount.data.farm_count);
        console.log(fieldCount.data.farm_count);

        setPlantationCount(plantationCount.data.farm_count);
        console.log(plantationCount.data.farm_count);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user and admin counts:", error);
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  let data;

  // Dynamically change the UI content based on the type
  switch (type) {
    case "farms":
      data = {
        title: "Farms",
        isMoney: false,
        count: farmCount, // Ensure adminUserCount is used here
        icon: (
          <FontAwesomeIcon
            icon={faTractor}
            style={{
              color: "#1565C0",
              backgroundColor: "#BBDEFB",
            }}
            className="icon"
          />
        ),
        link: "View Farms",
        linkto: "/user/crop-health-management",
      };
      break;
    case "plantation_crop_farms":
      data = {
        title: "Plantation Crop Farms",
        isMoney: false,
        count: plantationCount,
        icon: (
          <FontAwesomeIcon
            icon={faLeaf}
            style={{
              color: "#2E7D32",
              backgroundColor: "#C8E6C9",
            }}
            className="icon"
          />
        ),
        link: "Explore Plantation",
        linkto: "/user/plantation-farms",
      };
      break;
    case "field_crop_farms":
      data = {
        title: "Field Crop Farms",
        isMoney: false,
        count: fieldCount,
        icon: (
          <FontAwesomeIcon
            icon={faSeedling}
            style={{
              color: "#EF6C00",
              backgroundColor: "#FFE0B2",
            }}
            className="icon"
          />
        ),
        link: "Explore Fields",
        linkto: "/user/field-farms",
      };
      break;

    default:
      // If no valid type is provided, set a fallback object to avoid "undefined" errors
      data = {
        title: "UNKNOWN TYPE",
        isMoney: false,
        count: 0,
        icon: <div>No Icon</div>,
        link: "No data available",
        linkto: "#",
      };
      break;
  }

  if (loading) {
    return <p>Loading...</p>; // Display a loading message while data is being fetched
  }

  return (
    <div className="item_listss">
      <div className="name">
        <p>Total {data.title}</p>
        {/* <span className="persentage positive">
                    <KeyboardArrowUpIcon />
                    20 %
                </span> */}
      </div>

      <div className="counts">
        {data.isMoney && <AttachMoneyOutlinedIcon />}
        {data.count}
      </div>

      <div className="see_item">
        <Link to={data.linkto}>
          <p>{data.link}</p>
        </Link>
        {data.icon}
      </div>
    </div>
  );
}

export default ItemLists;
